import { useEffect, useState } from "react";
import { useFirebaseFriendsDataFetch } from "../contexts/FirebaseConnectionContext";
import { getDoc, doc } from "firebase/firestore";
import { db } from "../firebase-confg";
import { useAuth } from "../contexts/AuthContext";
import HeaderShadowSeparator from "../components/parts/separator/HeaderShadowSeparator";
import PagesHeader from "../components/header/pagesHeader/PagesHeader";
import FriendCard from "../components/friends/FriendCard";
import FriendsSearchBar from "../components/friends/FriendsSearchBar";
import OtherUserCard from "../components/friends/OtherUserCard";
import FriendModal from "../components/friends/FriendModal";
import { getFriendsSearchResultInDatabase } from "../utils/helper";

const Friends = () => {
  const { friendsIdList } = useFirebaseFriendsDataFetch();
  const [friends, setFriends] = useState([]);
  const { currentUser } = useAuth();
  const [searchString, setSearchString] = useState("");
  const [searchListResult, setSearchListResult] = useState([]);
  const [modal, setModal] = useState({ show: false, id: "", pseudo: "" });

  const headerContent = (
    <>
      <h1 className="pagesHeader-title">Mes amis</h1>
    </>
  );

  const handleSearchString = (e) => {
    e.preventDefault();
    setSearchString(e.target.value);
  };

  const handleFriendCard = (e) => {
    e.preventDefault();
    setModal({
      show: true,
      id: e.target.parentNode.id,
      pseudo: e.target.parentNode.getAttribute("data-pseudo"),
    });
  };

  //Manage the research of new friends
  useEffect(() => {
    // console.log("first useeffect")
    getFriendsSearchResultInDatabase(currentUser.user.uid, searchString).then(
      (result) => setSearchListResult(result)
    );
  }, [currentUser.user.uid, searchString]);

  //Manage the friends list
  useEffect(() => {
    const friendsArray = friendsIdList.map(async (friendId) => {
      const friend = await getDoc(doc(db, "users", friendId));
      return friend;
    });
    Promise.all(friendsArray).then((data) => setFriends(data));
    // console.log("friends use effect");
  }, [friendsIdList]);

  return (
    <main className="main-logged">
      <HeaderShadowSeparator css="bg-ivory" />
      <PagesHeader child={headerContent} />
      {modal.show ? (
        <FriendModal setShowModal={setModal} modal={modal} />
      ) : (
        <>
          {" "}
          <div className="flex justify-center w-full">
            <FriendsSearchBar
              search={searchString}
              handleSearchBar={handleSearchString}
            />
          </div>
          {searchString === "" ? (
            <div className="md:grid md:grid-cols-2 lg:grid-cols-4 global-px gap-4">
              {friends.map((friend) => {
                return (
                  <FriendCard
                    key={friend.id}
                    friend={friend}
                    handleClick={handleFriendCard}
                  />
                );
              })}
            </div>
          ) : (
            <div className="mx-2 global-px">
              <p className="italic">
                Le pseudo ou l'email doit être exact pour retrouver la personne
              </p>
              <h2 className="font-bold">
                Résultats de la recherche : {searchString}
              </h2>
              <div className="md:grid md:grid-cols-2 lg:grid-cols-4">
                {searchListResult.length === 0 ? (
                  <p>Aucun résultat</p>
                ) : (
                  searchListResult.map((user) => {
                    return (
                      <OtherUserCard
                        key={user.id}
                        otherUser={user}
                        friends={friends}
                        setSearchString={setSearchString}
                      />
                    );
                  })
                )}
              </div>
            </div>
          )}
        </>
      )}
    </main>
  );
};

export default Friends;
